import React from 'react';
import { SortableElement, SortableHandle } from 'react-sortable-hoc';
import UploadButton from '../UploadButton';
import Input from '../Input';
import TextArea from '../TextArea';

const DragHandle = SortableHandle(props => (
    <div className="drag-point">
        <i className="fas fa-sort"></i>
    </div>
))

const Sortable = SortableElement(props => {
    return (
        <div className="sortable-item col-12">
            <div className="d-flex">
                <div>
                    <DragHandle {...props} />
                    <div className="delete-point" index={props.itemIndex} onClick={props.deleteButtonHandler}>
                        <i className="far fa-trash-alt"></i>
                    </div>
                </div>
                <div className="w-100">
                    <div className="row">
                        <div className="col-6">
                            <div className="form-group">
                                <label>Name</label>
                                <Input name={`quotes.${props.itemIndex}.name`}
                                       value={props.element.name} onChange={props.onChange} />
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="form-group">
                                <label>Position</label>
                                <Input name={`quotes.${props.itemIndex}.position`}
                                       value={props.element.position} onChange={props.onChange} />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-6">
                            <div className="form-group">
                                <label>Quote</label>
                                <TextArea name={`quotes.${props.itemIndex}.quote`}
                                          value={props.element.quote} onChange={props.onChange} />
                            </div>
                        </div>
                        <div className="col-6 d-flex">
                            <div>
                                <label>Изображение</label>
                                <div className="images">
                                    <div className="img-container">
                                        <div className="img-wrap">
                                            <img src={props.element.img}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="pt-3">
                                <UploadButton name={`quotes.${props.itemIndex}.img`}
                                              index={props.itemIndex} onChange={props.onChange}/>
                                <div className="delete" onClick={props.deleteButtonHandler}>
                                    <i className="far fa-trash-alt"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
});

export default Sortable;
